import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTranslation = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m8 0c-4.409 0-8 3.591-8 8s3.591 8 8 8 8-3.591 8-8-3.591-8-8-8zm7.093 7.556h-2.88c-.07-2.667-.8-4.943-1.902-6.276 2.667.924 4.605 3.36 4.782 6.276zm-7.537-6.596v6.596h-2.88c.106-3.343 1.333-6.134 2.88-6.596zm0 7.484v6.596c-1.547-.462-2.774-3.253-2.88-6.596zm.888 6.596v-6.596h2.88c-.106 3.343-1.333 6.134-2.88 6.596zm0-7.484v-6.596c1.547.462 2.774 3.253 2.88 6.596zm-2.754-6.276c-1.086 1.333-1.832 3.609-1.903 6.276h-2.88c.177-2.916 2.115-5.352 4.782-6.276zm-4.783 7.164h2.88c.07 2.667.8 4.943 1.902 6.276-2.667-.924-4.605-3.36-4.782-6.276zm9.404 6.276c1.085-1.333 1.831-3.609 1.902-6.276h2.88c-.177 2.916-2.115 5.352-4.782 6.276z",
		fill: "#fff"
	})
});
export default SvgTranslation;
